import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Peter Noble
 * id 90994A54-72AA-498F-8806-AAD466CC21BD
 * name alert-octagon-outline
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alert-octagon-outline.svg
 * tags
 * - Alert / Error 
 */
export const AlertOctagonOutlineIcon = createSvgIcon(<><path d="M8.27,3L3,8.27V15.73L8.27,21H15.73C17.5,19.24 21,15.73 21,15.73V8.27L15.73,3M9.1,5H14.9L19,9.1V14.9L14.9,19H9.1L5,14.9V9.1M11,15H13V17H11V15M11,7H13V13H11V7" /></>, 'AlertOctagonOutlineIcon');
export default AlertOctagonOutlineIcon